import type { OwaDate } from 'owa-datetime';
import { action } from 'satcheljs';
import type { CalendarEvent } from 'owa-calendar-types';
import type { SurfaceUserOptions } from 'owa-calendar-surface-core';
import type { PerformanceDatapoint } from 'owa-analytics';

export const selectedDateChanged = action(
    'dayGrid-selectedDateChanged',
    (scenarioId: string, newDate: OwaDate) => ({
        scenarioId,
        newDate,
    })
);

export const selectedItemChanged = action(
    'dayGrid-selectedItemChanged',
    (scenarioId: string, selectionItem: CalendarEvent) => ({
        scenarioId,
        selectionItem,
    })
);

export const refreshDayGrid = action(
    'dayGrid-refreshDayGrid',
    (scenarioId: string, perfDatapoint?: PerformanceDatapoint | undefined) => ({
        scenarioId,
        perfDatapoint,
    })
);

export const updateUserOptions = action(
    'dayGrid-updateUserOptions',
    (scenarioId: string, userOptions: SurfaceUserOptions) => ({
        scenarioId,
        userOptions,
    })
);
